let divPo_cale = $("<div>");
let rows_calen = $("<div>")
    .addClass("row ")
    .appendTo(divPo_cale);
let note_cal = $("<div>")
    .addClass("row note_cal")
    .appendTo(divPo_cale);
//Fecha seleccionada
let dateSelected = $("<input>")
    .addClass("dateSelected")
    .appendTo(rows_calen);
dateSelected.attr("type", "hidden");

//Select
let col1 = $("<div>")
    .addClass("col s12")
    .appendTo(rows_calen);
let ca_selct = $("<select>").appendTo(col1);

// hora
let coln = $("<div>")
    .addClass("col s12 cal-hora")
    .appendTo(rows_calen);
let col2 = $("<div>")
    .addClass("input-field col s6")
    .appendTo(coln);
col2.text("Seleccione hora");
let col3 = $("<div>")
    .addClass("input-field huor-field col s6")
    .appendTo(coln);
let ico = $("<i>")
    .addClass("material-icons prefix icon-clock")
    .appendTo(col3);
let hour_cal = $("<input>")
    .addClass("hour")
    .appendTo(col3);
hour_cal.attr("type", "text");

//comentarios
let col4 = $("<div>")
    .addClass("col s12 left-align")
    .appendTo(rows_calen);
col4.text("Agregar un comentario:");
let col5 = $("<div>")
    .addClass("col s12 ")
    .appendTo(rows_calen);
let textComent = $("<textarea>")
    .addClass("textComent")
    .appendTo(col5);

let col6 = $("<div>")
    .addClass("col s12")
    .appendTo(rows_calen);
let btnSave = $("<a>")
    .addClass("waves-effect waves-light btn btncomment")
    .text("Guardar")
    .appendTo(col5);

let optCale = {
    none: "Seleccionar una acción",
    note: "Crear nota",
    appoin: "Crear cita",
    call: "Crear llamada"
};

for (const key in optCale) {
    if (optCale.hasOwnProperty(key)) {
        const element = optCale[key];
        const op = $("<option>").appendTo(ca_selct);
        op.text(element);
        op.attr("value", key);
    }
}

ca_selct.addClass("browser-default select-todo");
let calendar1;
let Daycalendar = [];
function calendarStart(dataKey) {
    calendar1 = $("#calendar1").calendar({
        months: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Deciembre"
        ],
        days: ["D", "L", "M", "M", "J", "V", "S"],
        color: "transparent",
        dates: dataKey,
        event: {
            initial: function(data) {
                //console.log(data)
                const btl = document.querySelector(
                    "#calendar1 > header > span.button.left"
                );
                btl.innerHTML = '<i class="material-icons">chevron_left</i>';
                const btr = document.querySelector(
                    "#calendar1 > header > span.button.right"
                );
                btr.innerHTML = '<i class="material-icons">chevron_right</i>';
                $(btl).click(function () {
                    dayCalendar(Daycalendar);
                })
                $(btr).click(function () {
                    dayCalendar(Daycalendar);
                })
                $(document).click(function(e) {
                    const close = $(e.target).parents(".calendar-frame")[0];
                    const clock = $(e.target).parents(".td-fadein")[0];

                    const clock_capa = e.target.classList.contains(
                        "td-overlay"
                    );
                    const td_fadein=e.target.classList.contains(
                        "td-fadein"
                    );
                    /*console.log(close,clock,clock_capa,e.target.classList.contains(
                        "td-fadein"
                    ));*/

                    if (
                        close == undefined &&
                        clock == undefined &&
                        clock_capa == false &&
                        td_fadein == false
                    ) {
                        try {
                            $(".calendar-frame .joy-active").removeClass(
                                "joy-active"
                            );
                            $(".calendar-frame .selected").removeClass(
                                "selected"
                            );
                        } catch (e) {}
                    }
                });
            },
            onSelect: function(event) {
                $(".dateSelected").val(event.label);
            },
            popover: {
                style: true,
                class: "calendar-comment",
                rows: {}, //All days
                template: divPo_cale,
                methods: {
                    names: {
                        class: ["btncomment"],
                        id: []
                    },
                    ready: function() {
                        $(".hour").timeDropper({
                            format: "hh:mm A ",
                            meridians: true,
                            setCurrentTime: true
                        });
                        $(".textComent").keydown(function() {
                            var el = this;
                            setTimeout(function() {
                                el.style.cssText = "height:auto;";
                                // for box-sizing other than "content-box" use:
                                // el.style.cssText = '-moz-box-sizing:content-box';
                                el.style.cssText =
                                    "height:" + el.scrollHeight + "px";
                            }, 0);
                        });
                    },
                    click_btncomment: function() {
                        const cale = $(".calendar-frame .selected .joy-active");
                        const data_todo = {
                            type: cale[0].querySelector(".select-todo").value,
                            hour: cale[0].querySelector(".td-input").value,
                            text: cale[0].querySelector(".textComent").value,
                            prospects_id: document.querySelector(
                                "#idViewsCliPros"
                            ).value,
                            users_id: document.querySelector("#iduser").value,
                            type_user: document.querySelector("#type_user")
                                .value,
                            date: $(".dateSelected").val(),
                            action: "saveCallProspect"
                        };
                        if (data_todo.text.trim() == "") {
                            swal({
                                text: "Debes escribir un texto",
                                icon: imageURL,
                                button: "OK!"
                            });
                            return false;
                        }
                        if (data_todo.hour.trim() == "") {
                            swal({
                                text: "Debes digitar una hora",
                                icon: imageURL,
                                button: "OK!"
                            });
                            return false;
                        }
                        if (data_todo.type.trim() == "none") {
                            swal({
                                text: "Debes seleccionar una acción",
                                icon: imageURL,
                                button: "OK!"
                            });
                            return false;
                        }
                        swal({
                            text: "Espere un momento",
                            icon: imageURL,
                            button: false
                        });
                        //console.log(https + "saveCallProspect");
                        $.ajax({
                            url: https + "saveCallProspect",
                            method: "POST",
                            data: data_todo,
                            success: function(data) {
                                if ($.trim(data[1]) == "1") {
                                    const comment = data[0];
                                    let type;
                                    if (comment.type == "appoin") {
                                        type = "Cita";
                                    } else if (comment.type == "note") {
                                        type = "Note";
                                    } else if (comment.type == "call") {
                                        type = "LLamada";
                                    }
                                    //console.log(data);
                                    swal.close();

                                    M.toast({
                                        html: type + " creada con exito",
                                        classes: "rounded"
                                    });
                                    setTimeout(function() {
                                        comment_(
                                            comment,
                                            "#content .todo_active"
                                        );
                                        $(
                                            ".calendar-frame .selected "
                                        ).addClass("active-" + comment.type);
                                        let Daycalendar=[];
                                        const date_ = comment.date.split("/");
                                        let day = date_[0].split("")[0] == 0 ? date_[0].split("")[1] : date_[0];
                                        let month = date_[1].split("")[0] == 0 ? date_[1].split("")[1] : date_[1];
                                        let item_day={
                                            day: day,
                                            note:comment.text.split(" ").length > 6
                                            ? comment.text
                                                  .split(" ")
                                                  .slice(0, 6)
                                                  .join(" ")
                                            : comment.text,
                                            hour: comment.hour,
                                            month: month,
                                            id: comment.id,
                                            resul: false
                                        };
                                        Daycalendar.push(item_day);
                                        
                                        calendar1.close();
                                    }, 200);
                                } else if ($.trim(data) == "2") {
                                    swal({
                                        text:
                                            "No tiene los permisos necesarios",
                                        icon: imageURL,
                                        button: "OK!"
                                    });
                                } else {
                                    swal({
                                        text: "Error, hubo problemas",
                                        icon: imageURL,
                                        button: "OK!"
                                    });
                                }
                            }
                        });
                        //console.log(data_todo);
                    }
                }
            }
        }
    });
    calendar1.close();
    //console.log(calendar1.day(24));
}

function comment_(comment, actIna) {
    let type;
    if (comment.type == "appoin") {
        type = "Cita";
    } else if (comment.type == "note") {
        type = "Note";
    } else if (comment.type == "call") {
        type = "LLamada";
    }
    const p1 = $("<div>")
        .addClass(
            "row todo_list " +
                comment.type +
                " valign-wrapper scale-transition scale-out"
        )
        .attr("data-id", comment.id)
        .attr("data-type", comment.type);

    //Hour
    const t_hour = $("<div>")
        .addClass("col s4 todo_hour ")
        .appendTo(p1);
    const h_huor_h = $("<h4>")
        .addClass("align-center")
        .appendTo(t_hour);
    h_huor_h.text(comment.hour);

    const h_date_h = $("<h6>")
        .addClass("align-center")
        .appendTo(t_hour);
    h_date_h.text(comment.date);

    const t_border = $("<div>")
        .addClass("col s6 todo_border")
        .appendTo(p1);
    const t_bor_row = $("<div>")
        .addClass("row")
        .appendTo(t_border);
    const t_b_rowD = $("<div>")
        .addClass("col s12")
        .appendTo(t_bor_row);
    $("<h5>")
        .text(type)
        .addClass("title_todo")
        .appendTo(t_b_rowD); //title_todo
    const t_commt = $("<div>")
        .addClass("col s12 todo_commet")
        .appendTo(t_bor_row);
    $("<span>")
        .text(comment.text)
        .appendTo(t_commt);

    const t_check = $("<div>")
        .addClass("col s2 todo_check")
        .appendTo(p1);
    const t_cH4 = $("<div>")
        .addClass("center-align")
        .appendTo(t_check);
    const t_cL = $("<label>").appendTo(t_cH4);
    const t_cT = $("<input>")
        .attr("type", "checkbox")
        .addClass("filled-in")
        .appendTo(t_cL);
    $("<span>").appendTo(t_cL);
    //$("");
    const date_ = comment.date.split("/");
    let day = date_[0].split("")[0] == 0 ? date_[0].split("")[1] : date_[0];
    let month = date_[1].split("")[0] == 0 ? date_[1].split("")[1] : date_[1];
    if (actIna == "#content .todo_inactive") {
        //console.log(actIna);
        t_cT.attr("checked", "checked");
        t_cT.attr("data-status", "inactive");
        $(t_cT).click(comment_status);

        Daycalendar.push({
            day: day,
            note:
                comment.text.split(" ").length > 6
                    ? comment.text
                          .split(" ")
                          .slice(0, 6)
                          .join(" ")
                    : comment.text,
            hour: comment.hour,
            month: month,
            id: comment.id,
            resul: true
        });
    } else {
        $(t_cT).click(comment_status);
        t_cT.attr("data-status", "active");
        Daycalendar.push({
            day: day,
            note:
                comment.text.split(" ").length > 6
                    ? comment.text
                          .split(" ")
                          .slice(0, 6)
                          .join(" ")
                    : comment.text,
            hour: comment.hour,
            month: month,
            id: comment.id,
            resul: false
        });
    }

    document.querySelector(actIna).appendChild(p1[0]);
    transition_scale_out(p1[0]);
}

function dayCalendar(Daycalendar){
    setTimeout(() => {
        for (const key in Daycalendar) {
            if (Daycalendar.hasOwnProperty(key)) {
                const elm = Daycalendar[key];
                if(document.getElementById("calendar1").dataset.month == elm.month){
                    calendar1
                    .day(elm.day)
                    .popover(".joy-popover .note_cal", function(ob) {
                        const item = $("<div>")
                            .addClass("col s12")
                            .appendTo(ob);

                        const conte = $("<div>")
                            .addClass("item-jay valign-wrapper")
                            .appendTo(item);

                        const t_check = $("<div>")
                            .addClass("col s2 todo_check valign-wrapper")
                            .appendTo(conte);
                        /*const t_cH4 = $("<span>")
                        .addClass("")
                        .appendTo(t_check);*/

                        const t_cL = $("<label>")
                            .addClass("center-align valign-wrapper")
                            .appendTo(t_check);

                        const t_cT = $("<input>")
                            .attr("type", "checkbox")
                            .addClass("filled-in")
                            .appendTo(t_cL);

                        const spanChe=$("<span>")
                        .appendTo(t_cL)
                        .attr("data-id", elm.id);
                        spanChe.click(function(){
                            //console.log(this);
                            const active=$("#content .todo_active [data-id='"+this.dataset.id+"'] .col.s2.todo_check input");
                            const inactive=$("#content .todo_inactive [data-id='"+this.dataset.id+"'] .col.s2.todo_check input");
                            if(active.length==1){
                                //
                                try {
                                    //console.log(active)
                                    comment_status(active[0]);
                                } catch (e) {
                                 console.error(e)
                                }finally{
                                    $($(this)
                                    .parents(".item-jay")[0]
                                    .querySelector(".todo_commet"))
                                    .addClass("decotation-item");
                                }


                            }else if(inactive.length==1){
                                try {
                                    comment_status(inactive[0]);
                                } catch (e) {
                                    console.error(e)
                                }finally{
                                    $(this)
                                    .parents(".item-jay")[0]
                                    .querySelector(".todo_commet").classList.remove("decotation-item");
                                }                                

                                
                            }

                        })

                        const text = $("<div>")
                            .addClass("col s10 left-align")
                            .appendTo(conte);

                        const spantext = $("<span>")
                            .text(elm.note)
                            .addClass("todo_commet")
                            .appendTo(text);

                        if (elm.resul) {
                            spantext.addClass("decotation-item");
                            t_cT.attr("checked", "checked");
                        }

                        //console.log(ob, elm);
                    });
                }

            }
        }
    }, 1000);
}

$(document).ready(function() {
    dayCalendar(Daycalendar);

});

function transition_scale_out(ob) {
    this.promise = function(ob) {
        this.p = ob;
        setTimeout(() => {
            //console.log(this.p);
            this.p.classList.remove("scale-out");
        }, 100);
        return this.p;
    };
    new this.promise(ob);
}

function comment_status(ob) {
    let this_check = this;
    if(ob.target==undefined){
        this_check = ob;
    }
    
    //console.log(this_check);
    this_check;
    let idp;
    let parent_todo;

    if (this_check.dataset.status == "active") {
        idp = $(this_check).parents("#content .todo_active .todo_list");
        parent_todo = "#content .todo_inactive";
    } else {
        idp = $(this_check).parents("#content .todo_inactive .todo_list");
        parent_todo = "#content .todo_active";
    }
    //console.log(idp);

    //if ($(this_check).prop("checked")) {
    const cale = $(".calendar-frame .selected .joy-active");

    $.ajax({
        url: https + "InactiveCallProspect",
        method: "POST",
        data: {
            prospects_id: document.querySelector("#idViewsCliPros").value,
            users_id: document.querySelector("#iduser").value,
            type_user: document.querySelector("#type_user").value,
            id: idp[0].dataset.id,
            status: this_check.dataset.status,
            action: "InactiveCallProspect"
        },
        success: function(data) {
            if ($.trim(data[1]) == "1") {
                const comment = data[0];
                setTimeout(function() {
                    $(idp).remove();
                    
                    comment_(comment, parent_todo);
                }, 500);
            } else if ($.trim(data) == "2") {
                swal({
                    text: "No tiene los permisos necesarios",
                    icon: imageURL,
                    button: "OK!"
                });
            } else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!"
                });
            }
        }
    });
    //console.log($(this).parents("#content .todo_list"),[this]);
    //}
}

$(document).ready(function() {
    if($("#calendar1").length==1){
        const cale = $(".calendar-frame .selected .joy-active");
        $.ajax({
            url: https + "SerchCallProspect",
            method: "POST",
            data: {
                prospects_id: document.querySelector("#idViewsCliPros").value,
                users_id: document.querySelector("#iduser").value,
                type_user: document.querySelector("#type_user").value,
                action: "SerchCallProspect"
            },
            success: function(data) {
                let keydate = {};
                if ($.trim(data[1]) == "1") {
                    const comment = data[0];
                    setTimeout(function() {
                        //console.log(comment);
                        //comment_(comment)
                        //console.log(comment);
                        for (let index = 0; index < comment.length + 1; index++) {
                            if (index < comment.length) {
                                const comobj = comment[index];
                                if (keydate[index]) {
                                    //keydate[comobj.type]
                                } else {
                                    keydate[index - 1] = {
                                        class: "active-" + comobj.type,
                                        key: []
                                    };
                                }
                                if (comobj.status == "active") {
                                    comment_(comobj, "#content .todo_active");
    
                                    keydate[index - 1].key.push(
                                        new Date(
                                            comobj.date
                                                .split("/")
                                                .reverse()
                                                .join(",")
                                        )
                                    );
                                    /* {
                                        class: "active-appoin",
                                        key: [
                                            new Date(2019, 7, 4), // Jan 4th
                                            new Date(2019, 7, 10), // Jan 10th
                                            new Date(2019, 7, 30) // Jan 15th
                                        ]
                                        popover: {
                                            style: false,
                                            class: "calendar-comment",
                                            template: "popover_gutand",
                                            rowsKey: [0], //All days
                                            methods: {}
                                        }
                                    }, */
                                } else {
                                    keydate[index - 1].key.push(
                                        new Date(
                                            comobj.date
                                                .split("/")
                                                .reverse()
                                                .join(",")
                                        )
                                    );
                                    comment_(comobj, "#content .todo_inactive");
                                }
                            }
    
                            if (index == comment.length) {
                                calendarStart(keydate);
                            }
                        }
                    }, 100);
                } else if ($.trim(data) == "2") {
                    swal({
                        text: "No tiene los permisos necesarios",
                        icon: imageURL,
                        button: "OK!"
                    });
                } else {
                    swal({
                        text: "Error, hubo problemas",
                        icon: imageURL,
                        button: "OK!"
                    });
                }
            }
        });
    }
});

/* <div class="row todo_list appoin valign-wrapper">//p1
    <div class="col s4 todo_hour ">//t_hour
      <h4>8:30 AM</h4>//h_huor_h
    </div>

    <div class="col s6 todo_border">//t_border
        <div class="row">//t_bor_row
            <div class="col s12">//t_b_rowD
                <h5 class="title_todo">//title_todo
                    Nota
                </h5>
            </div>

            <div class="col s12 todo_commet">//t_commt
                <span>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has.
                </span>
            </div>

        </div>

    </div>

    <div class="col s2 todo_check">//t_check
        <h4 class="center-align">//t_cH4
            <label>//t_cL
                <input type="checkbox" class="filled-in"  />//t_cT
                <span></span>
            </label>
        </h4>
    </div>

</div>  

*/
